import { ChangeDetectionStrategy, Component, HostBinding, inject, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseController } from '../../../core/abstractions/base.controller';
import { ApiResponseModel } from '../../../models/core/api-response.model';
import { SimpleItemModel } from '../../../models/simple-item.model';
import { UserModel } from '../../../models/user.model';
import { RolesResource } from '../../../services/resources/roles.resource';
import { UsersResource } from '../../../services/resources/users.resource';

@Component({
    selector: 'sl-users-form',
    templateUrl: './users-form.component.html',
    styleUrls: ['./users-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsersFormComponent extends BaseController<UserModel> implements OnInit {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    @HostBinding('class.editing') addClassEditing = this.isEdit;

    roles: Observable<ApiResponseModel<SimpleItemModel[]>>;
    languages: SimpleItemModel[];

    protected override readonly _entityResource = inject(UsersResource);

    private readonly rolesResource = inject(RolesResource);
    private readonly formBuilder = inject(UntypedFormBuilder);

    override ngOnInit(): void {
        super.ngOnInit();
        this.setupForm();

        this.roles = this.rolesResource.getAll().pipe(
            map(r => {
                const items: SimpleItemModel[] = [];

                r.value.forEach(i =>
                    items.push(
                        new SimpleItemModel({
                            id: i.id,
                            label: i.name
                        })
                    )
                );

                return new ApiResponseModel({
                    value: items
                });
            })
        );
        this.addClassEditing = this.isEdit;
    }

    private setupForm(): void {
        const controlValue = undefined;
        this.formGroup = this.formBuilder.group({
            windowsUser: new FormControl(controlValue, undefined),
            username: new FormControl(controlValue, undefined),
            firstName: new FormControl(controlValue, undefined),
            lastName: new FormControl(controlValue, undefined),
            employeeNumber: new FormControl(controlValue, undefined),
            function: new FormControl(controlValue, undefined),
            roleId: new FormControl(controlValue, Validators.required),
            phone: new FormControl(controlValue, undefined),
            email: new FormControl(controlValue, undefined),
            languageId: new FormControl(controlValue, undefined),
            getsNotified: new FormControl(controlValue, undefined),
            approvalRight: new FormControl(controlValue, undefined),
            mobilePhoneNumber: new FormControl(controlValue, undefined)
        });
    }
}
